/**
 * The ArticuLearn social profiles the marketing footer links out to.
 *
 * They live here rather than inline in the template for the same reason the
 * store listings live in appStoreLinks.js: a second consumer is foreseeable
 * (a JSON-LD `sameAs` block naming the same profiles) and two copies of a URL
 * drift. The footer is the only consumer today.
 * @readonly
 */
export const INSTAGRAM_URL = "https://www.instagram.com/articulearnai/";
export const FACEBOOK_URL =
  "https://www.facebook.com/people/ArticuLearn-AI/61553472174242/";
export const TIKTOK_URL = "https://www.tiktok.com/@articulearn.ai";
